/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduleGroup } from './ScheduleGroup';
import {
    ScheduleGroupFromJSON,
    ScheduleGroupFromJSONTyped,
    ScheduleGroupToJSON,
    ScheduleGroupToJSONTyped,
} from './ScheduleGroup';

/**
 * 
 * @export
 * @interface BodyPopulateQueueApiTasksPopulateQueuePost
 */
export interface BodyPopulateQueueApiTasksPopulateQueuePost {
    /**
     * 
     * @type {number}
     * @memberof BodyPopulateQueueApiTasksPopulateQueuePost
     */
    groupId: number;
    /**
     * 
     * @type {ScheduleGroup}
     * @memberof BodyPopulateQueueApiTasksPopulateQueuePost
     */
    schedule: ScheduleGroup;
}

/**
 * Check if a given object implements the BodyPopulateQueueApiTasksPopulateQueuePost interface.
 */
export function instanceOfBodyPopulateQueueApiTasksPopulateQueuePost(value: object): value is BodyPopulateQueueApiTasksPopulateQueuePost {
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('schedule' in value) || value['schedule'] === undefined) return false;
    return true;
}

export function BodyPopulateQueueApiTasksPopulateQueuePostFromJSON(json: any): BodyPopulateQueueApiTasksPopulateQueuePost {
    return BodyPopulateQueueApiTasksPopulateQueuePostFromJSONTyped(json, false);
}

export function BodyPopulateQueueApiTasksPopulateQueuePostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyPopulateQueueApiTasksPopulateQueuePost {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['group_id'],
        'schedule': ScheduleGroupFromJSON(json['schedule']),
    };
}

export function BodyPopulateQueueApiTasksPopulateQueuePostToJSON(json: any): BodyPopulateQueueApiTasksPopulateQueuePost {
    return BodyPopulateQueueApiTasksPopulateQueuePostToJSONTyped(json, false);
}

export function BodyPopulateQueueApiTasksPopulateQueuePostToJSONTyped(value?: BodyPopulateQueueApiTasksPopulateQueuePost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['groupId'],
        'schedule': ScheduleGroupToJSON(value['schedule']),
    };
}

